/* @generated */
// prettier-ignore
if (Intl.DisplayNames && typeof Intl.DisplayNames.__addLocaleData === 'function') {
  Intl.DisplayNames.__addLocaleData({
  "data": {
    "patterns": {
      "locale": "{0} ({1})"
    },
    "types": {
      "calendar": {
        "long": {
          "buddhist": "बौद्ध दिनदर्शिका",
          "chinese": "चीनी दिनदर्शिका",
          "coptic": "कॉप्टिक दिनदर्शिका",
          "dangi": "डांगी दिनदर्शिका",
          "ethiopic": "इथिओपिक दिनदर्शिका",
          "ethiopic-amete-alem": "इतिओपिक अमेटे अलेम दिनदर्शिका",
          "gregorian": "ग्रेगोरियन दिनदर्शिका",
          "hebrew": "यहूदी दिनदर्शिका",
          "indian": "भारतीय राष्ट्रीय दिनदर्शिका",
          "islamic": "मुस्लिम दिनदर्शिका",
          "islamic-civil": "मुस्लिम- नागरी दिनदर्शिका",
          "islamic-rgsa": "islamic-rgsa",
          "islamic-tbla": "islamic-tbla",
          "islamic-umalqura": "मुस्लिम दिनदर्शिका उम-अल-कुरा",
          "iso8601": "(ISO-8601) दिनदर्शिका",
          "japanese": "जपानी दिनदर्शिका",
          "persian": "फारसी दिनदर्शिका",
          "roc": "मिनगुओ दिनदर्शिका"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "currency": {
        "long": {
          "ADP": "ADP",
          "AED": "संयुक्त अरब अमीरात दिरहॅम",
          "AFA": "AFA",
          "AFN": "अफगाण अफगाणी",
          "ALK": "ALK",
          "ALL": "अल्बानियन लेक",
          "AMD": "आर्मेनियन द्रॅम",
          "ANG": "नेदरलँडचा अँटिलीन गिल्डर",
          "AOA": "अँगोलन क्वॅन्झा",
          "AOK": "AOK",
          "AON": "AON",
          "AOR": "AOR",
          "ARA": "ARA",
          "ARL": "ARL",
          "ARM": "ARM",
          "ARP": "ARP",
          "ARS": "अर्जेंटाइन पेसो",
          "ATS": "ATS",
          "AUD": "ऑस्ट्रेलियन डॉलर",
          "AWG": "अरुबा फ्लोरिन",
          "AZM": "AZM",
          "AZN": "अझरबैझानी मानाट",
          "BAD": "BAD",
          "BAM": "बोस्निया-हर्जेगोविना विनिमय मार्क",
          "BAN": "BAN",
          "BBD": "बार्बाडियन डॉलर",
          "BDT": "बांगलादेशी टका",
          "BEC": "BEC",
          "BEF": "BEF",
          "BEL": "BEL",
          "BGL": "BGL",
          "BGM": "BGM",
          "BGN": "बल्गेरियन लेव",
          "BGO": "BGO",
          "BHD": "बाहरिनी दिनार",
          "BIF": "बुरुंडियन फ्रँक",
          "BMD": "बर्मुडा डॉलर",
          "BND": "ब्रुनेई डॉलर",
          "BOB": "बोलिव्हियन बोलिव्हियानो",
          "BOL": "BOL",
          "BOP": "BOP",
          "BOV": "BOV",
          "BRB": "BRB",
          "BRC": "BRC",
          "BRE": "BRE",
          "BRL": "ब्राझिलियन रियाल",
          "BRN": "BRN",
          "BRR": "BRR",
          "BRZ": "BRZ",
          "BSD": "बहामी डॉलर",
          "BTN": "भूतानी एंगल्ट्रम",
          "BUK": "BUK",
          "BWP": "बोट्सवानन पुला",
          "BYB": "BYB",
          "BYN": "बेलारुशियन रुबल",
          "BYR": "बेलारुशियन रुबल (2000–2016)",
          "BZD": "बेलीझ डॉलर",
          "CAD": "कॅनडियन डॉलर",
          "CDF": "काँगोलीज फ्रँक",
          "CHE": "CHE",
          "CHF": "स्विस फ्रँक",
          "CHW": "CHW",
          "CLE": "CLE",
          "CLF": "CLF",
          "CLP": "चिली पेसो",
          "CNH": "चिनी युआन (ऑफशोर)",
          "CNX": "CNX",
          "CNY": "चीनी युआन",
          "COP": "कोलंबियन पेसो",
          "COU": "COU",
          "CRC": "कोस्टारिकन कोलोन",
          "CSD": "CSD",
          "CSK": "CSK",
          "CUC": "क्यूबन विनिमय पेसो",
          "CUP": "क्यूबन पेसो",
          "CVE": "केप व्हर्डेयन एस्कुडो",
          "CYP": "CYP",
          "CZK": "झेक प्रजासत्ताक कोरुना",
          "DDM": "DDM",
          "DEM": "DEM",
          "DJF": "जिबौटियन फ्रँक",
          "DKK": "डॅनिश क्रोन",
          "DOP": "डोमिनिकन पेसो",
          "DZD": "अल्जेरियन दिनार",
          "ECS": "ECS",
          "ECV": "ECV",
          "EEK": "EEK",
          "EGP": "इजिप्शियन पाउंड",
          "ERN": "इरिट्रियन नाक्फा",
          "ESA": "ESA",
          "ESB": "ESB",
          "ESP": "ESP",
          "ETB": "इथिओपियन बिर",
          "EUR": "युरो",
          "FIM": "FIM",
          "FJD": "फिजियन डॉलर",
          "FKP": "फॉकलंड आयलंड पाउंड",
          "FRF": "FRF",
          "GBP": "ब्रिटिश पाऊंड",
          "GEK": "GEK",
          "GEL": "जॉर्जियन लारी",
          "GHC": "GHC",
          "GHS": "घानीयन सेडी",
          "GIP": "जिब्राल्टर पाउंड",
          "GMD": "गाम्बियन डालासी",
          "GNF": "गिनी फ्रँक",
          "GNS": "GNS",
          "GQE": "GQE",
          "GRD": "GRD",
          "GTQ": "ग्वाटेमालाचे क्वेत्झाल",
          "GWE": "GWE",
          "GWP": "GWP",
          "GYD": "गयाना डॉलर",
          "HKD": "हाँगकाँग डॉलर",
          "HNL": "होन्डुरन लेंपिरा",
          "HRD": "HRD",
          "HRK": "क्रोएशियन कूना",
          "HTG": "हैती गोअर्ड",
          "HUF": "हंगेरियन फॉरिन्ट",
          "IDR": "इंडोनेशियन रुपिया",
          "IEP": "IEP",
          "ILP": "ILP",
          "ILR": "ILR",
          "ILS": "ईस्त्रायली न्यू शेकेल",
          "INR": "भारतीय रुपया",
          "IQD": "इराकी दिनार",
          "IRR": "इराणी रियाल",
          "ISJ": "ISJ",
          "ISK": "आइसलँडिक क्रोना",
          "ITL": "ITL",
          "JMD": "जमैकन डॉलर",
          "JOD": "जॉर्डनियन दिनार",
          "JPY": "जपानी येन",
          "KES": "केनियन शिलिंग",
          "KGS": "किरगिस्तानी सॉम",
          "KHR": "कंबोडियन रियेल",
          "KMF": "कोमोरियन फ्रँक",
          "KPW": "उत्तर कोरियन वॉन",
          "KRH": "KRH",
          "KRO": "KRO",
          "KRW": "दक्षिण कोरियन वॉन",
          "KWD": "कुवैती दिनार",
          "KYD": "केमेन आयलॅंड डॉलर",
          "KZT": "कझाकिस्तानी तेंगे",
          "LAK": "लाओशियन किप",
          "LBP": "लेबनीज पाउंड",
          "LKR": "श्रीलंकन रुपया",
          "LRD": "लाइबेरियन डॉलर",
          "LSL": "लेसोटो लोटी",
          "LTL": "लिथुआनियन लिटास",
          "LTT": "LTT",
          "LUC": "LUC",
          "LUF": "LUF",
          "LUL": "LUL",
          "LVL": "लाट्व्हियन लाट्झ",
          "LVR": "LVR",
          "LYD": "लिबियाचा दिनार",
          "MAD": "मोरोक्को दिरहॅम",
          "MAF": "MAF",
          "MCF": "MCF",
          "MDC": "MDC",
          "MDL": "मोल्डोवन लेउ",
          "MGA": "मालागासी एरियारी",
          "MGF": "MGF",
          "MKD": "मॅसेडोनियन देनार",
          "MKN": "MKN",
          "MLF": "MLF",
          "MMK": "म्यानमार क्याट",
          "MNT": "मंगोलियन टुग्रिक",
          "MOP": "मॅकॅनीज् पटाका",
          "MRO": "मॉरिटानियन ओगिया (1973–2017)",
          "MRU": "मॉरिटानियन ओगिया",
          "MTL": "MTL",
          "MTP": "MTP",
          "MUR": "मॉरिशियन रुपी",
          "MVP": "MVP",
          "MVR": "मालदीवियन रुफिया",
          "MWK": "मालावियन क्वाचा",
          "MXN": "मेक्सिको पेसो",
          "MXP": "MXP",
          "MXV": "MXV",
          "MYR": "मलेशियन रिंगिट",
          "MZE": "MZE",
          "MZM": "MZM",
          "MZN": "मोझांबिकन मेटिकल",
          "NAD": "नमिबियन डॉलर",
          "NGN": "नायजेरियन नायरा",
          "NIC": "NIC",
          "NIO": "निकाराग्वेचा कोर्डोबा",
          "NLG": "NLG",
          "NOK": "नॉर्वेजियन क्रोन",
          "NPR": "नेपाळी रुपया",
          "NZD": "न्यूझीलँड डॉलर",
          "OMR": "ओमानी रियाल",
          "PAB": "पनामा बाल्बोआ",
          "PEI": "PEI",
          "PEN": "पेरुवियन सोल",
          "PES": "PES",
          "PGK": "पापुआ न्यू गिनीयन किना",
          "PHP": "फिलिपिनी पेसो",
          "PKR": "पाकिस्तानी रुपया",
          "PLN": "पोलिश झ्लॉटी",
          "PLZ": "PLZ",
          "PTE": "PTE",
          "PYG": "पराग्वे ग्वारानी",
          "QAR": "कतारी रियाल",
          "RHD": "RHD",
          "ROL": "ROL",
          "RON": "रोमानियन लेऊ",
          "RSD": "सर्बियन दिनार",
          "RUB": "रशियन रुबल",
          "RUR": "RUR",
          "RWF": "रवांडा फ्रँक",
          "SAR": "सौदी रियाल",
          "SBD": "सोलोमन आयलँड्स डॉलर",
          "SCR": "सेशेलोईस रुपी",
          "SDD": "SDD",
          "SDG": "सुदानी पाउंड",
          "SDP": "SDP",
          "SEK": "स्वीडिश क्रोना",
          "SGD": "सिंगापूर डॉलर",
          "SHP": "सेंट हेलेना पाउंड",
          "SIT": "SIT",
          "SKK": "SKK",
          "SLL": "सिएरा लिऑनचा लिऑन",
          "SOS": "सोमाली शिलिंग",
          "SRD": "सुरिनामी डॉलर",
          "SRG": "SRG",
          "SSP": "दक्षिण सुदानी पाउंड",
          "STD": "साओ टोम आणि प्रिन्सिपे डोबरा (1977–2017)",
          "STN": "साओ टोम आणि प्रिन्सिपे डोबरा",
          "SUR": "SUR",
          "SVC": "SVC",
          "SYP": "सीरियन पाउंड",
          "SZL": "स्वाझी लीलांगेनी",
          "THB": "थाई बाहत",
          "TJR": "TJR",
          "TJS": "ताजकीस्तानी सोमोनी",
          "TMM": "TMM",
          "TMT": "तुर्कमेनिस्तानी मानाट",
          "TND": "ट्यूनिशियन दिनार",
          "TOP": "टोंगन पाआंगा",
          "TPE": "TPE",
          "TRL": "TRL",
          "TRY": "तुर्की लिरा",
          "TTD": "त्रिनिदाद आणि टोबॅगो डॉलर",
          "TWD": "न्यू तैवान डॉलर",
          "TZS": "टांझानियन शिलिंग",
          "UAH": "युक्रेनियन रिवनिया",
          "UAK": "UAK",
          "UGS": "UGS",
          "UGX": "युगांडा शिलिंग",
          "USD": "यूएस डॉलर",
          "USN": "USN",
          "USS": "USS",
          "UYI": "UYI",
          "UYP": "UYP",
          "UYU": "उरुग्वेचा पेसो",
          "UYW": "UYW",
          "UZS": "उझबेकिस्तानी सोम",
          "VEB": "VEB",
          "VEF": "व्हेनेझुएला बोलिव्हार (2008–2018)",
          "VES": "व्हेनेझुएला बोलिव्हार",
          "VND": "व्हिएतनामी डोंग",
          "VNN": "VNN",
          "VUV": "वानुआतु वाटु",
          "WST": "सामोअन टाला",
          "XAF": "मध्य आफ्रिकन [CFA] फ्रँक",
          "XAG": "XAG",
          "XAU": "XAU",
          "XBA": "XBA",
          "XBB": "XBB",
          "XBC": "XBC",
          "XBD": "XBD",
          "XCD": "पूर्व कॅरीबियन डॉलर",
          "XDR": "XDR",
          "XEU": "XEU",
          "XFO": "XFO",
          "XFU": "XFU",
          "XOF": "पश्चिम आफ्रिकन [CFA] फ्रँक",
          "XPD": "XPD",
          "XPF": "[CFP] फ्रँक",
          "XPT": "XPT",
          "XRE": "XRE",
          "XSU": "XSU",
          "XTS": "XTS",
          "XUA": "XUA",
          "XXX": "अज्ञात चलन",
          "YDD": "YDD",
          "YER": "येमेनी रियाल",
          "YUD": "YUD",
          "YUM": "YUM",
          "YUN": "YUN",
          "YUR": "YUR",
          "ZAL": "ZAL",
          "ZAR": "दक्षिण आफ्रिकी रँड",
          "ZMK": "झांबियन क्वाचा (1968–2012)",
          "ZMW": "झांबियन क्वाचा",
          "ZRN": "ZRN",
          "ZRZ": "ZRZ",
          "ZWD": "ZWD",
          "ZWL": "ZWL",
          "ZWR": "ZWR"
        },
        "narrow": {
        },
        "short": {
        }
      },
      "dateTimeField": {
        "long": {
          "day": "दिवस",
          "dayOfYear": "वर्षातील दिवस",
          "dayperiod": "AM/PM",
          "era": "युग",
          "hour": "तास",
          "minute": "मिनिट",
          "month": "महिना",
          "quarter": "तिमाही",
          "second": "सेकंद",
          "timeZoneName": "वेळ क्षेत्र",
          "weekOfMonth": "महिन्याचा आठवडा",
          "weekOfYear": "आठवडा",
          "weekday": "आठवड्याचा दिवस",
          "weekdayOfMonth": "महिन्यातील साप्ताहिक दिवस",
          "year": "वर्ष"
        },
        "narrow": {
          "day": "दिवस",
          "dayOfYear": "वर्षातील दिवस",
          "dayperiod": "AM/PM",
          "era": "युग",
          "hour": "तास",
          "minute": "मि.",
          "month": "महिना",
          "quarter": "तिमाही",
          "second": "से.",
          "timeZoneName": "क्षेत्र",
          "weekOfMonth": "महिन्याचा आठ.",
          "weekOfYear": "आठवडा",
          "weekday": "आठवड्याचा दिवस",
          "weekdayOfMonth": "महिन्यातील साप्ता. दिवस",
          "year": "वर्ष"
        },
        "short": {
          "day": "दिवस",
          "dayOfYear": "वर्षातील दिवस",
          "dayperiod": "AM/PM",
          "era": "युग",
          "hour": "तास",
          "minute": "मि.",
          "month": "महिना",
          "quarter": "तिमाही",
          "second": "से.",
          "timeZoneName": "क्षेत्र",
          "weekOfMonth": "महिन्याचा आठ.",
          "weekOfYear": "आठवडा",
          "weekday": "आठवड्याचा दिवस",
          "weekdayOfMonth": "महिन्यातील साप्ता. दिवस",
          "year": "वर्ष"
        }
      },
      "language": {
        "dialect": {
          "long": {
            "aa": "अफार",
            "ab": "अबखेजियन",
            "ace": "अचीनी",
            "ach": "अकोली",
            "ada": "अडांग्मे",
            "ady": "अडिघे",
            "ae": "अवेस्तन",
            "af": "अफ्रिकान्स",
            "afh": "अफ्रिहिली",
            "agq": "अघेम",
            "ain": "ऐनू",
            "ak": "अकान",
            "akk": "अक्केडियन",
            "ale": "अलेउत",
            "alt": "दक्षिणात्य अल्ताई",
            "am": "अम्हारिक",
            "an": "अर्गोनीज",
            "ang": "पुरातन इंग्रजी",
            "anp": "अंगिका",
            "ar": "अरबी",
            "ar-001": "आधुनिक प्रमाणित अरबी",
            "arc": "अ‍ॅरेमाइक",
            "arn": "मापुची",
            "arp": "आरापाहो",
            "arw": "आरावाक",
            "as": "आसामी",
            "asa": "असु",
            "ast": "अस्तुरियन",
            "av": "अ‍ॅव्हेरिक",
            "awa": "अवधी",
            "ay": "ऐमरा",
            "az": "अझरबैजानी",
            "ba": "बष्किर",
            "bal": "बलुची",
            "ban": "बालिनीज",
            "bas": "बसा",
            "be": "बेलारुशियन",
            "bej": "बेजा",
            "bem": "बेम्बा",
            "bez": "बेना",
            "bg": "बल्गेरियन",
            "bgn": "पश्चिमी बालोची",
            "bho": "भोजपुरी",
            "bi": "बिस्लामा",
            "bik": "बिकोल",
            "bin": "बिनी",
            "bla": "सिक्सिका",
            "bm": "बाम्बारा",
            "bn": "बंगाली",
            "bo": "तिबेटी",
            "br": "ब्रेतॉन",
            "bra": "ब्रज",
            "brx": "बोडो",
            "bs": "बोस्नियन",
            "bua": "बुरियात",
            "bug": "बगिनीस",
            "byn": "ब्लिन",
            "ca": "कातालान",
            "cad": "कॅड्डो",
            "car": "कॅरिब",
            "cch": "अत्सम",
            "ccp": "चाकमा",
            "ce": "चेचेन",
            "ceb": "सिबुआनो",
            "cgg": "किगा",
            "ch": "कॅमोरो",
            "chb": "चिब्चा",
            "chg": "छागाताइ",
            "chk": "चूकीसे",
            "chm": "मारी",
            "chn": "चिनूक जारगॉन",
            "cho": "चोक्तौ",
            "chp": "शिपेव्यान",
            "chr": "चेरोकी",
            "chy": "शेयेन्न",
            "ckb": "मध्य कुर्दिश",
            "co": "कॉर्सिकन",
            "cop": "कॉप्टिक",
            "cr": "क्री",
            "crh": "क्राइमीन तुर्की",
            "crs": "सेसेल्वा क्रिओल फ्रेंच",
            "cs": "झेक",
            "csb": "काशुबियन",
            "cu": "चर्च स्लाव्हिक",
            "cv": "चूवाश",
            "cy": "वेल्श",
            "da": "डॅनिश",
            "dak": "डाकोटा",
            "dar": "दार्गवा",
            "dav": "तायता",
            "de": "जर्मन",
            "de-AT": "ऑस्ट्रियन जर्मन",
            "de-CH": "स्विस हाय जर्मन",
            "del": "डेलावेयर",
            "den": "स्लाव्ह",
            "dgr": "डोग्रिब",
            "din": "डिन्का",
            "dje": "झार्मा",
            "doi": "डोगरी",
            "dsb": "लोअर सोर्बियन",
            "dua": "दुआला",
            "dum": "मिडल डच",
            "dv": "दिवेही",
            "dyo": "जोला-फॉन्यी",
            "dyu": "ड्युला",
            "dz": "झोंगखा",
            "dzg": "दाझागा",
            "ebu": "एम्बू",
            "ee": "एवे",
            "efi": "एफिक",
            "egy": "प्राचीन इजिप्शियन",
            "eka": "एकाजुक",
            "el": "ग्रीक",
            "elx": "एलामाइट",
            "en": "इंग्रजी",
            "en-AU": "ऑस्ट्रेलियन इंग्रजी",
            "en-CA": "कॅनडियन इंग्रजी",
            "en-GB": "ब्रिटिश इंग्रजी",
            "en-US": "अमेरिकन इंग्रजी",
            "enm": "मिडल इंग्रजी",
            "eo": "एस्परान्टो",
            "es": "स्पॅनिश",
            "es-419": "लॅटिन अमेरिकन स्पॅनिश",
            "es-ES": "युरोपियन स्पॅनिश",
            "es-MX": "मेक्सिकन स्पॅनिश",
            "et": "इस्टोनियन",
            "eu": "बास्क",
            "ewo": "इवोन्डो",
            "fa": "फारसी",
            "fa-AF": "दारी",
            "fan": "फँग",
            "fat": "फन्टी",
            "ff": "फुलाह",
            "fi": "फिन्निश",
            "fil": "फिलिपिनो",
            "fj": "फिजियन",
            "fo": "फरोइज",
            "fon": "फॉन",
            "fr": "फ्रेंच",
            "fr-CA": "कॅनडियन फ्रेंच",
            "fr-CH": "स्विस फ्रेंच",
            "frc": "केजॉन फ्रेंच",
            "frm": "मिडल फ्रेंच",
            "fro": "पुरातन फ्रेंच",
            "frr": "उत्तरी फ्रिशियन",
            "frs": "पौर्वात्य फ्रिशियन",
            "fur": "फ्रियुलियान",
            "fy": "पश्चिमी फ्रिशियन",
            "ga": "आयरिश",
            "gaa": "गा",
            "gag": "गागाउझ",
            "gan": "गॅन चिनी",
            "gay": "गायो",
            "gba": "बाया",
            "gd": "स्कॉटिश गेलिक",
            "gez": "गीझ",
            "gil": "जिल्बरटीज",
            "gl": "गॅलिशियन",
            "gmh": "मिडल हाय जर्मन",
            "gn": "गुआरनी",
            "goh": "पुरातन हाइ जर्मन",
            "gon": "गाँडी",
            "gor": "गोरोन्तालो",
            "got": "गॉथिक",
            "grb": "ग्रेबो",
            "grc": "प्राचीन ग्रीक",
            "gsw": "स्विस जर्मन",
            "gu": "गुजराती",
            "guz": "गसी",
            "gv": "मांक्स",
            "gwi": "ग्विच’इन",
            "ha": "हौसा",
            "hai": "हैडा",
            "hak": "हाक्का चिनी",
            "haw": "हवाईयन",
            "he": "हिब्रू",
            "hi": "हिंदी",
            "hil": "हिलीगेनॉन",
            "hit": "हिट्टिते",
            "hmn": "माँग",
            "ho": "हिरी मॉटू",
            "hr": "क्रोएशियन",
            "hsb": "अप्पर सॉर्बियन",
            "hsn": "शियांग चिनी",
            "ht": "हैतीयन क्रेओल",
            "hu": "हंगेरियन",
            "hup": "हूपा",
            "hy": "आर्मेनियन",
            "hz": "हरेरो",
            "ia": "इंटरलिंग्वा",
            "iba": "इबान",
            "ibb": "इबिबिओ",
            "id": "इंडोनेशियन",
            "ie": "इन्टरलिंग",
            "ig": "ईग्बो",
            "ii": "सिचुआन यी",
            "ik": "इनूपियाक",
            "ilo": "इलोको",
            "inh": "इंगुश",
            "io": "इडौ",
            "is": "आईसलँडिक",
            "it": "इटालियन",
            "iu": "इनुक्तीटुट",
            "ja": "जपानी",
            "jbo": "लोज्बान",
            "jgo": "गोम्बा",
            "jmc": "मशामे",
            "jpr": "जुदेओ-फारसी",
            "jrb": "जुदेओ-अरबी",
            "jv": "जावानीज",
            "ka": "जॉर्जियन",
            "kaa": "कारा-कल्पक",
            "kab": "कबाइल",
            "kac": "काचिन",
            "kaj": "ज्जु",
            "kam": "काम्बा",
            "kaw": "कावी",
            "kbd": "कबार्डियन",
            "kcg": "त्याप",
            "kde": "माकोन्दे",
            "kea": "काबवर्दियानु",
            "kfo": "कोरो",
            "kg": "काँगो",
            "kgp": "kgp",
            "kha": "खासी",
            "kho": "खोतानीस",
            "khq": "कोयरा चीनी",
            "ki": "किकुयू",
            "kj": "क्वान्यामा",
            "kk": "कझाक",
            "kkj": "काको",
            "kl": "कलाल्लिसत",
            "kln": "कालेंजीन",
            "km": "ख्मेर",
            "kmb": "किम्बन्दु",
            "kn": "कन्नड",
            "ko": "कोरियन",
            "koi": "कोमी-परम्याक",
            "kok": "कोंकणी",
            "kos": "कोसरियन",
            "kpe": "क्पेल्ले",
            "kr": "कनुरी",
            "krc": "कराचय-बाल्कर",
            "krl": "करेलियन",
            "kru": "कुरूख",
            "ks": "काश्मीरी",
            "ksb": "शांबाला",
            "ksf": "बाफिया",
            "ksh": "कोलोग्नियन",
            "ku": "कुर्दिश",
            "kum": "कुमीक",
            "kut": "कुतेनाई",
            "kv": "कोमी",
            "kw": "कोर्निश",
            "ky": "किरगीझ",
            "la": "लॅटिन",
            "lad": "लादीनो",
            "lag": "लांगी",
            "lah": "लाह्न्डा",
            "lam": "लाम्बा",
            "lb": "लक्झेंबर्गिश",
            "lez": "लेझ्घीयन",
            "lg": "गांडा",
            "li": "लिंबूर्गिश",
            "lij": "lij",
            "lkt": "लाकोटा",
            "ln": "लिंगाला",
            "lo": "लाओ",
            "lol": "मोंगो",
            "lou": "ल्युसियाना क्रिओल",
            "loz": "लोझि",
            "lrc": "उत्तरी ल्युरी",
            "lt": "लिथुआनियन",
            "lu": "ल्यूबा-कटांगा",
            "lua": "लुबा-लुलुआ",
            "lui": "लुइसेनो",
            "lun": "लुन्डा",
            "luo": "ल्युओ",
            "lus": "मिझो",
            "luy": "ल्युइया",
            "lv": "लात्व्हियन",
            "mad": "मादुरीस",
            "mag": "मगही",
            "mai": "मैथिली",
            "mak": "मकस्सर",
            "man": "मन्डिन्गो",
            "mas": "मसाई",
            "mdf": "मोक्ष",
            "mdr": "मंडार",
            "men": "मेन्डे",
            "mer": "मेरू",
            "mfe": "मोरिस्येन",
            "mg": "मलागसी",
            "mga": "मिडल आयरिश",
            "mgh": "माखुव्हा-मीट्टो",
            "mgo": "मीटा",
            "mh": "मार्शलीज",
            "mi": "माओरी",
            "mic": "मिकमॅक",
            "min": "मिनांग्काबाउ",
            "mk": "मॅसेडोनियन",
            "ml": "मल्याळम",
            "mn": "मंगोलियन",
            "mnc": "मान्चु",
            "mni": "मणिपुरी",
            "moh": "मोहॉक",
            "mos": "मोस्सी",
            "mr": "मराठी",
            "ms": "मलय",
            "mt": "माल्टिज्",
            "mua": "मुंडांग",
            "mul": "एकाधिक भाषा",
            "mus": "क्रीक",
            "mwl": "मिरांडिज्",
            "mwr": "मारवाडी",
            "my": "बर्मी",
            "myv": "एर्झ्या",
            "mzn": "माझानदेरानी",
            "na": "नउरू",
            "nan": "मिन नान चिनी",
            "nap": "नेपोलिटान",
            "naq": "नामा",
            "nb": "नॉर्वेजियन बोकमाल",
            "nd": "उत्तर देबेली",
            "nds": "लो जर्मन",
            "nds-NL": "लो सॅक्सन",
            "ne": "नेपाळी",
            "new": "नेवारी",
            "ng": "डोंगा",
            "nia": "नियास",
            "niu": "नियुआन",
            "nl": "डच",
            "nl-BE": "फ्लेमिश",
            "nmg": "क्वासिओ",
            "nn": "नॉर्वेजियन न्योर्स्क",
            "nnh": "जिएम्बून",
            "no": "नोर्वेजियन",
            "nog": "नोगाई",
            "non": "पुरातन नॉर्स",
            "nqo": "एन्को",
            "nr": "दक्षिणात्य देबेली",
            "nso": "उत्तरी सोथो",
            "nus": "नुएर",
            "nv": "नावाजो",
            "nwc": "अभिजात नेवारी",
            "ny": "न्यान्जा",
            "nym": "न्यामवेझी",
            "nyn": "न्यानकोल",
            "nyo": "न्योरो",
            "nzi": "न्झिमा",
            "oc": "ऑक्सितान",
            "oj": "ओजिब्वा",
            "om": "ओरोमो",
            "or": "उडिया",
            "os": "ओस्सेटिक",
            "osa": "ओसेज",
            "ota": "ओटोमान तुर्किश",
            "pa": "पंजाबी",
            "pag": "पंगासीनान",
            "pal": "पहलवी",
            "pam": "पाम्पान्गा",
            "pap": "पापियामेन्टो",
            "pau": "पालाउआन",
            "pcm": "नायजिरिअन पिजिन",
            "peo": "पुरातन फारसी",
            "phn": "फोनिशियन",
            "pi": "पाली",
            "pl": "पोलिश",
            "pon": "पोह्नपियन",
            "prg": "प्रुशियन",
            "pro": "पुरातन प्रोव्हेन्सल",
            "ps": "पश्तो",
            "pt": "पोर्तुगीज",
            "pt-BR": "ब्राझिलियन पोर्तुगीज",
            "pt-PT": "युरोपियन पोर्तुगीज",
            "qu": "क्वेचुआ",
            "quc": "कीशेइ",
            "raj": "राजस्थानी",
            "rap": "रापानुई",
            "rar": "रारोटोंगन",
            "rhg": "रोहिंग्या",
            "rm": "रोमान्श",
            "rn": "रुन्दी",
            "ro": "रोमानियन",
            "ro-MD": "मोल्डाव्हियन",
            "rof": "रोम्बो",
            "rom": "रोमानी",
            "ru": "रशियन",
            "rup": "अरोमानियन",
            "rw": "किन्यार्वान्डा",
            "rwk": "रव्हा",
            "sa": "संस्कृत",
            "sad": "सँडवे",
            "sah": "साखा",
            "sam": "सामरिटान अरॅमिक",
            "saq": "सांबुरू",
            "sas": "सासाक",
            "sat": "संताली",
            "sba": "गाम्बे",
            "sbp": "सांगु",
            "sc": "सर्दिनियन",
            "scn": "सिसिलियन",
            "sco": "स्कॉट्स",
            "sd": "सिंधी",
            "sdh": "दक्षिणी कुर्दिश",
            "se": "उत्तरी सामी",
            "seh": "सेना",
            "sel": "सेल्कप",
            "ses": "कोयराबोरो सेन्नी",
            "sg": "सांगो",
            "sga": "पुरातन आयरिश",
            "sh": "सर्बो-क्रोएशियन",
            "shi": "ताशेल्हिट",
            "shn": "शॅन",
            "si": "सिंहला",
            "sid": "सिदामो",
            "sk": "स्लोव्हाक",
            "sl": "स्लोव्हेनियन",
            "sm": "सामोअन",
            "sma": "दक्षिणात्य सामी",
            "smj": "ल्युल सामी",
            "smn": "इनारी सामी",
            "sms": "स्कोल्ट सामी",
            "sn": "शोना",
            "snk": "सोनिन्के",
            "so": "सोमाली",
            "sog": "सोग्डिएन",
            "sq": "अल्बानियन",
            "sr": "सर्बियन",
            "srn": "स्रानान टॉन्गो",
            "srr": "सेरेर",
            "ss": "स्वाती",
            "ssy": "साहो",
            "st": "दक्षिणी सोथो",
            "su": "सुंदानीज",
            "suk": "सुकुमा",
            "sus": "सुसु",
            "sux": "सुमेरियन",
            "sv": "स्वीडिश",
            "sw": "स्वाहिली",
            "sw-CD": "काँगो स्वाहिली",
            "swb": "कोमोरियन",
            "syc": "अभिजात सिरियाक",
            "syr": "सिरियाक",
            "ta": "तामिळ",
            "te": "तेलगू",
            "tem": "टिम्ने",
            "teo": "तेसो",
            "ter": "तेरेनो",
            "tet": "तेतुम",
            "tg": "ताजिक",
            "th": "थाई",
            "ti": "तिग्रिन्या",
            "tig": "टाइग्रे",
            "tiv": "तिव",
            "tk": "तुर्कमेन",
            "tkl": "टोकेलाऊ",
            "tl": "टागालोग",
            "tlh": "क्लिंगोन",
            "tli": "लिंगित",
            "tmh": "तामाशेक",
            "tn": "त्स्वाना",
            "to": "टोंगन",
            "tog": "न्यासा टोन्गा",
            "tpi": "टोक पिसिन",
            "tr": "तुर्की",
            "trv": "तारोको",
            "ts": "सोंगा",
            "tsi": "सिम्शियन",
            "tt": "तातर",
            "tum": "तुम्बुका",
            "tvl": "टुवालु",
            "tw": "ट्वी",
            "twq": "तासाव्हाक",
            "ty": "ताहितीयन",
            "tyv": "टुवीनियन",
            "tzm": "मध्य अ‍ॅटलास तॅमाझाइट",
            "udm": "उदमुर्त",
            "ug": "उइगुर",
            "uga": "युगॅरिटिक",
            "uk": "युक्रेनियन",
            "umb": "उम्बुन्डु",
            "und": "अज्ञात भाषा",
            "ur": "उर्दू",
            "uz": "उझ्बेक",
            "vai": "वाई",
            "ve": "व्हेंदा",
            "vi": "व्हिएतनामी",
            "vo": "ओलापुक",
            "vot": "वॉटिक",
            "vun": "वुंजो",
            "wa": "वालून",
            "wae": "वालसेर",
            "wal": "वोलायता",
            "war": "वारे",
            "was": "वाशो",
            "wbp": "वार्लपिरी",
            "wo": "वोलोफ",
            "wuu": "व्हू चिनी",
            "xal": "काल्मिक",
            "xh": "खोसा",
            "xog": "सोगा",
            "yao": "याओ",
            "yap": "यापीस",
            "yav": "यांगबेन",
            "ybb": "येमबा",
            "yi": "यिद्दिश",
            "yo": "योरुबा",
            "yrl": "yrl",
            "yue": "कँटोनीज",
            "za": "झुआंग",
            "zap": "झेपोटेक",
            "zbl": "ब्लिसिम्बॉल्स",
            "zen": "झेनान्गा",
            "zgh": "प्रमाण मोरोक्कन तॅमॅझायट",
            "zh": "चीनी",
            "zh-Hans": "सरलीकृत चीनी",
            "zh-Hant": "पारंपारिक चीनी",
            "zu": "झुलू",
            "zun": "झुनी",
            "zxx": "भाषावैज्ञानिक सामग्री नाही",
            "zza": "झाझा"
          },
          "narrow": {
          },
          "short": {
            "az": "अझेरी",
            "en-GB": "यू.के. इंग्रजी",
            "en-US": "यू.एस. इंग्रजी"
          }
        },
        "standard": {
          "long": {
            "aa": "अफार",
            "ab": "अबखेजियन",
            "ace": "अचीनी",
            "ach": "अकोली",
            "ada": "अडांग्मे",
            "ady": "अडिघे",
            "ae": "अवेस्तन",
            "af": "अफ्रिकान्स",
            "afh": "अफ्रिहिली",
            "agq": "अघेम",
            "ain": "ऐनू",
            "ak": "अकान",
            "akk": "अक्केडियन",
            "ale": "अलेउत",
            "alt": "दक्षिणात्य अल्ताई",
            "am": "अम्हारिक",
            "an": "अर्गोनीज",
            "ang": "पुरातन इंग्रजी",
            "anp": "अंगिका",
            "ar": "अरबी",
            "ar-001": "अरबी (विश्व)",
            "arc": "अ‍ॅरेमाइक",
            "arn": "मापुची",
            "arp": "आरापाहो",
            "arw": "आरावाक",
            "as": "आसामी",
            "asa": "असु",
            "ast": "अस्तुरियन",
            "av": "अ‍ॅव्हेरिक",
            "awa": "अवधी",
            "ay": "ऐमरा",
            "az": "अझरबैजानी",
            "ba": "बष्किर",
            "bal": "बलुची",
            "ban": "बालिनीज",
            "bas": "बसा",
            "be": "बेलारुशियन",
            "bej": "बेजा",
            "bem": "बेम्बा",
            "bez": "बेना",
            "bg": "बल्गेरियन",
            "bgn": "पश्चिमी बालोची",
            "bho": "भोजपुरी",
            "bi": "बिस्लामा",
            "bik": "बिकोल",
            "bin": "बिनी",
            "bla": "सिक्सिका",
            "bm": "बाम्बारा",
            "bn": "बंगाली",
            "bo": "तिबेटी",
            "br": "ब्रेतॉन",
            "bra": "ब्रज",
            "brx": "बोडो",
            "bs": "बोस्नियन",
            "bua": "बुरियात",
            "bug": "बगिनीस",
            "byn": "ब्लिन",
            "ca": "कातालान",
            "cad": "कॅड्डो",
            "car": "कॅरिब",
            "cch": "अत्सम",
            "ccp": "चाकमा",
            "ce": "चेचेन",
            "ceb": "सिबुआनो",
            "cgg": "किगा",
            "ch": "कॅमोरो",
            "chb": "चिब्चा",
            "chg": "छागाताइ",
            "chk": "चूकीसे",
            "chm": "मारी",
            "chn": "चिनूक जारगॉन",
            "cho": "चोक्तौ",
            "chp": "शिपेव्यान",
            "chr": "चेरोकी",
            "chy": "शेयेन्न",
            "ckb": "मध्य कुर्दिश",
            "co": "कॉर्सिकन",
            "cop": "कॉप्टिक",
            "cr": "क्री",
            "crh": "क्राइमीन तुर्की",
            "crs": "सेसेल्वा क्रिओल फ्रेंच",
            "cs": "झेक",
            "csb": "काशुबियन",
            "cu": "चर्च स्लाव्हिक",
            "cv": "चूवाश",
            "cy": "वेल्श",
            "da": "डॅनिश",
            "dak": "डाकोटा",
            "dar": "दार्गवा",
            "dav": "तायता",
            "de": "जर्मन",
            "de-AT": "जर्मन (ऑस्ट्रिया)",
            "de-CH": "जर्मन (स्वित्झर्लंड)",
            "del": "डेलावेयर",
            "den": "स्लाव्ह",
            "dgr": "डोग्रिब",
            "din": "डिन्का",
            "dje": "झार्मा",
            "doi": "डोगरी",
            "dsb": "लोअर सोर्बियन",
            "dua": "दुआला",
            "dum": "मिडल डच",
            "dv": "दिवेही",
            "dyo": "जोला-फॉन्यी",
            "dyu": "ड्युला",
            "dz": "झोंगखा",
            "dzg": "दाझागा",
            "ebu": "एम्बू",
            "ee": "एवे",
            "efi": "एफिक",
            "egy": "प्राचीन इजिप्शियन",
            "eka": "एकाजुक",
            "el": "ग्रीक",
            "elx": "एलामाइट",
            "en": "इंग्रजी",
            "en-AU": "इंग्रजी (ऑस्ट्रेलिया)",
            "en-CA": "इंग्रजी (कॅनडा)",
            "en-GB": "इंग्रजी (युनायटेड किंगडम)",
            "en-US": "इंग्रजी (युनायटेड स्टेट्स)",
            "enm": "मिडल इंग्रजी",
            "eo": "एस्परान्टो",
            "es": "स्पॅनिश",
            "es-419": "स्पॅनिश (लॅटिन अमेरिका)",
            "es-ES": "स्पॅनिश (स्पेन)",
            "es-MX": "स्पॅनिश (मेक्सिको)",
            "et": "इस्टोनियन",
            "eu": "बास्क",
            "ewo": "इवोन्डो",
            "fa": "फारसी",
            "fa-AF": "फारसी (अफगाणिस्तान)",
            "fan": "फँग",
            "fat": "फन्टी",
            "ff": "फुलाह",
            "fi": "फिन्निश",
            "fil": "फिलिपिनो",
            "fj": "फिजियन",
            "fo": "फरोइज",
            "fon": "फॉन",
            "fr": "फ्रेंच",
            "fr-CA": "फ्रेंच (कॅनडा)",
            "fr-CH": "फ्रेंच (स्वित्झर्लंड)",
            "frc": "केजॉन फ्रेंच",
            "frm": "मिडल फ्रेंच",
            "fro": "पुरातन फ्रेंच",
            "frr": "उत्तरी फ्रिशियन",
            "frs": "पौर्वात्य फ्रिशियन",
            "fur": "फ्रियुलियान",
            "fy": "पश्चिमी फ्रिशियन",
            "ga": "आयरिश",
            "gaa": "गा",
            "gag": "गागाउझ",
            "gan": "गॅन चिनी",
            "gay": "गायो",
            "gba": "बाया",
            "gd": "स्कॉटिश गेलिक",
            "gez": "गीझ",
            "gil": "जिल्बरटीज",
            "gl": "गॅलिशियन",
            "gmh": "मिडल हाय जर्मन",
            "gn": "गुआरनी",
            "goh": "पुरातन हाइ जर्मन",
            "gon": "गाँडी",
            "gor": "गोरोन्तालो",
            "got": "गॉथिक",
            "grb": "ग्रेबो",
            "grc": "प्राचीन ग्रीक",
            "gsw": "स्विस जर्मन",
            "gu": "गुजराती",
            "guz": "गसी",
            "gv": "मांक्स",
            "gwi": "ग्विच’इन",
            "ha": "हौसा",
            "hai": "हैडा",
            "hak": "हाक्का चिनी",
            "haw": "हवाईयन",
            "he": "हिब्रू",
            "hi": "हिंदी",
            "hil": "हिलीगेनॉन",
            "hit": "हिट्टिते",
            "hmn": "माँग",
            "ho": "हिरी मॉटू",
            "hr": "क्रोएशियन",
            "hsb": "अप्पर सॉर्बियन",
            "hsn": "शियांग चिनी",
            "ht": "हैतीयन क्रेओल",
            "hu": "हंगेरियन",
            "hup": "हूपा",
            "hy": "आर्मेनियन",
            "hz": "हरेरो",
            "ia": "इंटरलिंग्वा",
            "iba": "इबान",
            "ibb": "इबिबिओ",
            "id": "इंडोनेशियन",
            "ie": "इन्टरलिंग",
            "ig": "ईग्बो",
            "ii": "सिचुआन यी",
            "ik": "इनूपियाक",
            "ilo": "इलोको",
            "inh": "इंगुश",
            "io": "इडौ",
            "is": "आईसलँडिक",
            "it": "इटालियन",
            "iu": "इनुक्तीटुट",
            "ja": "जपानी",
            "jbo": "लोज्बान",
            "jgo": "गोम्बा",
            "jmc": "मशामे",
            "jpr": "जुदेओ-फारसी",
            "jrb": "जुदेओ-अरबी",
            "jv": "जावानीज",
            "ka": "जॉर्जियन",
            "kaa": "कारा-कल्पक",
            "kab": "कबाइल",
            "kac": "काचिन",
            "kaj": "ज्जु",
            "kam": "काम्बा",
            "kaw": "कावी",
            "kbd": "कबार्डियन",
            "kcg": "त्याप",
            "kde": "माकोन्दे",
            "kea": "काबवर्दियानु",
            "kfo": "कोरो",
            "kg": "काँगो",
            "kgp": "kgp",
            "kha": "खासी",
            "kho": "खोतानीस",
            "khq": "कोयरा चीनी",
            "ki": "किकुयू",
            "kj": "क्वान्यामा",
            "kk": "कझाक",
            "kkj": "काको",
            "kl": "कलाल्लिसत",
            "kln": "कालेंजीन",
            "km": "ख्मेर",
            "kmb": "किम्बन्दु",
            "kn": "कन्नड",
            "ko": "कोरियन",
            "koi": "कोमी-परम्याक",
            "kok": "कोंकणी",
            "kos": "कोसरियन",
            "kpe": "क्पेल्ले",
            "kr": "कनुरी",
            "krc": "कराचय-बाल्कर",
            "krl": "करेलियन",
            "kru": "कुरूख",
            "ks": "काश्मीरी",
            "ksb": "शांबाला",
            "ksf": "बाफिया",
            "ksh": "कोलोग्नियन",
            "ku": "कुर्दिश",
            "kum": "कुमीक",
            "kut": "कुतेनाई",
            "kv": "कोमी",
            "kw": "कोर्निश",
            "ky": "किरगीझ",
            "la": "लॅटिन",
            "lad": "लादीनो",
            "lag": "लांगी",
            "lah": "लाह्न्डा",
            "lam": "लाम्बा",
            "lb": "लक्झेंबर्गिश",
            "lez": "लेझ्घीयन",
            "lg": "गांडा",
            "li": "लिंबूर्गिश",
            "lij": "lij",
            "lkt": "लाकोटा",
            "ln": "लिंगाला",
            "lo": "लाओ",
            "lol": "मोंगो",
            "lou": "ल्युसियाना क्रिओल",
            "loz": "लोझि",
            "lrc": "उत्तरी ल्युरी",
            "lt": "लिथुआनियन",
            "lu": "ल्यूबा-कटांगा",
            "lua": "लुबा-लुलुआ",
            "lui": "लुइसेनो",
            "lun": "लुन्डा",
            "luo": "ल्युओ",
            "lus": "मिझो",
            "luy": "ल्युइया",
            "lv": "लात्व्हियन",
            "mad": "मादुरीस",
            "mag": "मगही",
            "mai": "मैथिली",
            "mak": "मकस्सर",
            "man": "मन्डिन्गो",
            "mas": "मसाई",
            "mdf": "मोक्ष",
            "mdr": "मंडार",
            "men": "मेन्डे",
            "mer": "मेरू",
            "mfe": "मोरिस्येन",
            "mg": "मलागसी",
            "mga": "मिडल आयरिश",
            "mgh": "माखुव्हा-मीट्टो",
            "mgo": "मीटा",
            "mh": "मार्शलीज",
            "mi": "माओरी",
            "mic": "मिकमॅक",
            "min": "मिनांग्काबाउ",
            "mk": "मॅसेडोनियन",
            "ml": "मल्याळम",
            "mn": "मंगोलियन",
            "mnc": "मान्चु",
            "mni": "मणिपुरी",
            "moh": "मोहॉक",
            "mos": "मोस्सी",
            "mr": "मराठी",
            "ms": "मलय",
            "mt": "माल्टिज्",
            "mua": "मुंडांग",
            "mul": "एकाधिक भाषा",
            "mus": "क्रीक",
            "mwl": "मिरांडिज्",
            "mwr": "मारवाडी",
            "my": "बर्मी",
            "myv": "एर्झ्या",
            "mzn": "माझानदेरानी",
            "na": "नउरू",
            "nan": "मिन नान चिनी",
            "nap": "नेपोलिटान",
            "naq": "नामा",
            "nb": "नॉर्वेजियन बोकमाल",
            "nd": "उत्तर देबेली",
            "nds": "लो जर्मन",
            "nds-NL": "लो जर्मन (नेदरलँड)",
            "ne": "नेपाळी",
            "new": "नेवारी",
            "ng": "डोंगा",
            "nia": "नियास",
            "niu": "नियुआन",
            "nl": "डच",
            "nl-BE": "डच (बेल्जियम)",
            "nmg": "क्वासिओ",
            "nn": "नॉर्वेजियन न्योर्स्क",
            "nnh": "जिएम्बून",
            "no": "नोर्वेजियन",
            "nog": "नोगाई",
            "non": "पुरातन नॉर्स",
            "nqo": "एन्को",
            "nr": "दक्षिणात्य देबेली",
            "nso": "उत्तरी सोथो",
            "nus": "नुएर",
            "nv": "नावाजो",
            "nwc": "अभिजात नेवारी",
            "ny": "न्यान्जा",
            "nym": "न्यामवेझी",
            "nyn": "न्यानकोल",
            "nyo": "न्योरो",
            "nzi": "न्झिमा",
            "oc": "ऑक्सितान",
            "oj": "ओजिब्वा",
            "om": "ओरोमो",
            "or": "उडिया",
            "os": "ओस्सेटिक",
            "osa": "ओसेज",
            "ota": "ओटोमान तुर्किश",
            "pa": "पंजाबी",
            "pag": "पंगासीनान",
            "pal": "पहलवी",
            "pam": "पाम्पान्गा",
            "pap": "पापियामेन्टो",
            "pau": "पालाउआन",
            "pcm": "नायजिरिअन पिजिन",
            "peo": "पुरातन फारसी",
            "phn": "फोनिशियन",
            "pi": "पाली",
            "pl": "पोलिश",
            "pon": "पोह्नपियन",
            "prg": "प्रुशियन",
            "pro": "पुरातन प्रोव्हेन्सल",
            "ps": "पश्तो",
            "pt": "पोर्तुगीज",
            "pt-BR": "पोर्तुगीज (ब्राझिल)",
            "pt-PT": "पोर्तुगीज (पोर्तुगाल)",
            "qu": "क्वेचुआ",
            "quc": "कीशेइ",
            "raj": "राजस्थानी",
            "rap": "रापानुई",
            "rar": "रारोटोंगन",
            "rhg": "रोहिंग्या",
            "rm": "रोमान्श",
            "rn": "रुन्दी",
            "ro": "रोमानियन",
            "ro-MD": "रोमानियन (मोल्डोव्हा)",
            "rof": "रोम्बो",
            "rom": "रोमानी",
            "ru": "रशियन",
            "rup": "अरोमानियन",
            "rw": "किन्यार्वान्डा",
            "rwk": "रव्हा",
            "sa": "संस्कृत",
            "sad": "सँडवे",
            "sah": "साखा",
            "sam": "सामरिटान अरॅमिक",
            "saq": "सांबुरू",
            "sas": "सासाक",
            "sat": "संताली",
            "sba": "गाम्बे",
            "sbp": "सांगु",
            "sc": "सर्दिनियन",
            "scn": "सिसिलियन",
            "sco": "स्कॉट्स",
            "sd": "सिंधी",
            "sdh": "दक्षिणी कुर्दिश",
            "se": "उत्तरी सामी",
            "seh": "सेना",
            "sel": "सेल्कप",
            "ses": "कोयराबोरो सेन्नी",
            "sg": "सांगो",
            "sga": "पुरातन आयरिश",
            "sh": "सर्बो-क्रोएशियन",
            "shi": "ताशेल्हिट",
            "shn": "शॅन",
            "si": "सिंहला",
            "sid": "सिदामो",
            "sk": "स्लोव्हाक",
            "sl": "स्लोव्हेनियन",
            "sm": "सामोअन",
            "sma": "दक्षिणात्य सामी",
            "smj": "ल्युल सामी",
            "smn": "इनारी सामी",
            "sms": "स्कोल्ट सामी",
            "sn": "शोना",
            "snk": "सोनिन्के",
            "so": "सोमाली",
            "sog": "सोग्डिएन",
            "sq": "अल्बानियन",
            "sr": "सर्बियन",
            "srn": "स्रानान टॉन्गो",
            "srr": "सेरेर",
            "ss": "स्वाती",
            "ssy": "साहो",
            "st": "दक्षिणी सोथो",
            "su": "सुंदानीज",
            "suk": "सुकुमा",
            "sus": "सुसु",
            "sux": "सुमेरियन",
            "sv": "स्वीडिश",
            "sw": "स्वाहिली",
            "sw-CD": "स्वाहिली (काँगो - किंशासा)",
            "swb": "कोमोरियन",
            "syc": "अभिजात सिरियाक",
            "syr": "सिरियाक",
            "ta": "तामिळ",
            "te": "तेलगू",
            "tem": "टिम्ने",
            "teo": "तेसो",
            "ter": "तेरेनो",
            "tet": "तेतुम",
            "tg": "ताजिक",
            "th": "थाई",
            "ti": "तिग्रिन्या",
            "tig": "टाइग्रे",
            "tiv": "तिव",
            "tk": "तुर्कमेन",
            "tkl": "टोकेलाऊ",
            "tl": "टागालोग",
            "tlh": "क्लिंगोन",
            "tli": "लिंगित",
            "tmh": "तामाशेक",
            "tn": "त्स्वाना",
            "to": "टोंगन",
            "tog": "न्यासा टोन्गा",
            "tpi": "टोक पिसिन",
            "tr": "तुर्की",
            "trv": "तारोको",
            "ts": "सोंगा",
            "tsi": "सिम्शियन",
            "tt": "तातर",
            "tum": "तुम्बुका",
            "tvl": "टुवालु",
            "tw": "ट्वी",
            "twq": "तासाव्हाक",
            "ty": "ताहितीयन",
            "tyv": "टुवीनियन",
            "tzm": "मध्य अ‍ॅटलास तॅमाझाइट",
            "udm": "उदमुर्त",
            "ug": "उइगुर",
            "uga": "युगॅरिटिक",
            "uk": "युक्रेनियन",
            "umb": "उम्बुन्डु",
            "und": "अज्ञात भाषा",
            "ur": "उर्दू",
            "uz": "उझ्बेक",
            "vai": "वाई",
            "ve": "व्हेंदा",
            "vi": "व्हिएतनामी",
            "vo": "ओलापुक",
            "vot": "वॉटिक",
            "vun": "वुंजो",
            "wa": "वालून",
            "wae": "वालसेर",
            "wal": "वोलायता",
            "war": "वारे",
            "was": "वाशो",
            "wbp": "वार्लपिरी",
            "wo": "वोलोफ",
            "wuu": "व्हू चिनी",
            "xal": "काल्मिक",
            "xh": "खोसा",
            "xog": "सोगा",
            "yao": "याओ",
            "yap": "यापीस",
            "yav": "यांगबेन",
            "ybb": "येमबा",
            "yi": "यिद्दिश",
            "yo": "योरुबा",
            "yrl": "yrl",
            "yue": "कँटोनीज",
            "za": "झुआंग",
            "zap": "झेपोटेक",
            "zbl": "ब्लिसिम्बॉल्स",
            "zen": "झेनान्गा",
            "zgh": "प्रमाण मोरोक्कन तॅमॅझायट",
            "zh": "चीनी",
            "zh-Hans": "सरलीकृत चीनी",
            "zh-Hant": "पारंपारिक चीनी",
            "zu": "झुलू",
            "zun": "झुनी",
            "zxx": "भाषावैज्ञानिक सामग्री नाही",
            "zza": "झाझा"
          },
          "narrow": {
          },
          "short": {
            "az": "अझेरी",
            "en-GB": "इंग्रजी (यू.के.)",
            "en-US": "इंग्रजी (यू.एस.)"
          }
        }
      },
      "region": {
        "long": {
          "001": "विश्व",
          "002": "आफ्रिका",
          "003": "उत्तर अमेरिका",
          "005": "दक्षिण अमेरिका",
          "009": "ओशनिया",
          "011": "पश्चिम आफ्रिका",
          "013": "मध्य अमेरिका",
          "014": "पूर्व आफ्रिका",
          "015": "उत्तर आफ्रिका",
          "017": "मध्य आफ्रिका",
          "018": "दक्षिणी आफ्रिका",
          "019": "अमेरिका",
          "021": "उत्तरी अमेरिका",
          "029": "कॅरीबियन",
          "030": "पूर्व आशिया",
          "034": "दक्षिण आशिया",
          "035": "दक्षिण पूर्व आशिया",
          "039": "दक्षिण युरोप",
          "053": "ऑस्‍ट्रेलेशिया",
          "054": "मेलानेशिया",
          "057": "मायक्रोनेशियन प्रदेश",
          "061": "पॉलिनेशिया",
          "142": "आशिया",
          "143": "मध्य आशिया",
          "145": "पश्चिम आशिया",
          "150": "युरोप",
          "151": "पूर्व युरोप",
          "154": "उत्तर युरोप",
          "155": "पश्चिम युरोप",
          "202": "उप-सहारा आफ्रिका",
          "419": "लॅटिन अमेरिका",
          "AC": "अ‍ॅसेन्शियन बेट",
          "AD": "अँडोरा",
          "AE": "संयुक्त अरब अमीरात",
          "AF": "अफगाणिस्तान",
          "AG": "अँटिग्वा आणि बर्बुडा",
          "AI": "अँग्विला",
          "AL": "अल्बानिया",
          "AM": "अर्मेनिया",
          "AO": "अंगोला",
          "AQ": "अंटार्क्टिका",
          "AR": "अर्जेंटिना",
          "AS": "अमेरिकन सामोआ",
          "AT": "ऑस्ट्रिया",
          "AU": "ऑस्ट्रेलिया",
          "AW": "अरुबा",
          "AX": "अ‍ॅलँड बेटे",
          "AZ": "अझरबैजान",
          "BA": "बोस्निया अणि हर्जेगोविना",
          "BB": "बार्बाडोस",
          "BD": "बांगलादेश",
          "BE": "बेल्जियम",
          "BF": "बुर्किना फासो",
          "BG": "बल्गेरिया",
          "BH": "बहारीन",
          "BI": "बुरुंडी",
          "BJ": "बेनिन",
          "BL": "सेंट बार्थेलेमी",
          "BM": "बर्मुडा",
          "BN": "ब्रुनेई",
          "BO": "बोलिव्हिया",
          "BQ": "कॅरिबियन नेदरलँड्स",
          "BR": "ब्राझिल",
          "BS": "बहामाज",
          "BT": "भूतान",
          "BV": "बोउवेट बेट",
          "BW": "बोट्सवाना",
          "BY": "बेलारूस",
          "BZ": "बेलिझे",
          "CA": "कॅनडा",
          "CC": "कोकोस (कीलिंग) बेटे",
          "CD": "काँगो - किंशासा",
          "CF": "केंद्रीय अफ्रिकी प्रजासत्ताक",
          "CG": "काँगो - ब्राझाविले",
          "CH": "स्वित्झर्लंड",
          "CI": "Côte d’Ivoire",
          "CK": "कुक बेटे",
          "CL": "चिली",
          "CM": "कॅमेरून",
          "CN": "चीन",
          "CO": "कोलम्बिया",
          "CP": "क्लिपरटोन बेट",
          "CR": "कोस्टा रिका",
          "CU": "क्यूबा",
          "CV": "केप व्हर्डे",
          "CW": "क्युरासाओ",
          "CX": "ख्रिसमस बेट",
          "CY": "सायप्रस",
          "CZ": "झेकिया",
          "DE": "जर्मनी",
          "DG": "दिएगो गार्सिया",
          "DJ": "जिबौटी",
          "DK": "डेन्मार्क",
          "DM": "डोमिनिका",
          "DO": "डोमिनिकन प्रजासत्ताक",
          "DZ": "अल्जीरिया",
          "EA": "स्यूटा आणि मेलिला",
          "EC": "इक्वाडोर",
          "EE": "एस्टोनिया",
          "EG": "इजिप्त",
          "EH": "पश्चिम सहारा",
          "ER": "एरिट्रिया",
          "ES": "स्पेन",
          "ET": "इथिओपिया",
          "EU": "युरोपीय संघ",
          "EZ": "युरोझोन",
          "FI": "फिनलंड",
          "FJ": "फिजी",
          "FK": "फॉकलंड बेटे",
          "FM": "मायक्रोनेशिया",
          "FO": "फेरो बेटे",
          "FR": "फ्रान्स",
          "GA": "गॅबॉन",
          "GB": "युनायटेड किंगडम",
          "GD": "ग्रेनेडा",
          "GE": "जॉर्जिया",
          "GF": "फ्रेंच गयाना",
          "GG": "ग्वेर्नसे",
          "GH": "घाना",
          "GI": "जिब्राल्टर",
          "GL": "ग्रीनलंड",
          "GM": "गाम्बिया",
          "GN": "गिनी",
          "GP": "ग्वाडेलोउपे",
          "GQ": "इक्वेटोरियल गिनी",
          "GR": "ग्रीस",
          "GS": "दक्षिण जॉर्जिया आणि दक्षिण सँडविच बेटे",
          "GT": "ग्वाटेमाला",
          "GU": "गुआम",
          "GW": "गिनी-बिसाउ",
          "GY": "गयाना",
          "HK": "हाँगकाँग एसएआर चीन",
          "HM": "हर्ड आणि मॅक्डोनाल्ड बेटे",
          "HN": "होंडुरास",
          "HR": "क्रोएशिया",
          "HT": "हैती",
          "HU": "हंगेरी",
          "IC": "कॅनरी बेटे",
          "ID": "इंडोनेशिया",
          "IE": "आयर्लंड",
          "IL": "इस्त्राइल",
          "IM": "आयल ऑफ मॅन",
          "IN": "भारत",
          "IO": "ब्रिटिश हिंद महासागर प्रदेश",
          "IQ": "इराक",
          "IR": "इराण",
          "IS": "आइसलँड",
          "IT": "इटली",
          "JE": "जर्सी",
          "JM": "जमैका",
          "JO": "जॉर्डन",
          "JP": "जपान",
          "KE": "केनिया",
          "KG": "किरगिझस्तान",
          "KH": "कंबोडिया",
          "KI": "किरीबाटी",
          "KM": "कोमोरोज",
          "KN": "सेंट किट्स आणि नेव्हिस",
          "KP": "उत्तर कोरिया",
          "KR": "दक्षिण कोरिया",
          "KW": "कुवेत",
          "KY": "केमन बेटे",
          "KZ": "कझाकस्तान",
          "LA": "लाओस",
          "LB": "लेबनॉन",
          "LC": "सेंट ल्यूसिया",
          "LI": "लिक्टेनस्टाइन",
          "LK": "श्रीलंका",
          "LR": "लायबेरिया",
          "LS": "लेसोथो",
          "LT": "लिथुआनिया",
          "LU": "लक्झेंबर्ग",
          "LV": "लाटव्हिया",
          "LY": "लिबिया",
          "MA": "मोरोक्को",
          "MC": "मोनॅको",
          "MD": "मोल्डोव्हा",
          "ME": "मोंटेनेग्रो",
          "MF": "सेंट मार्टिन",
          "MG": "मादागास्कर",
          "MH": "मार्शल बेटे",
          "MK": "उत्तर मॅसेडोनिया",
          "ML": "माली",
          "MM": "म्यानमार (बर्मा)",
          "MN": "मंगोलिया",
          "MO": "मकाओ एसएआर चीन",
          "MP": "उत्तरी मारियाना बेटे",
          "MQ": "मार्टिनिक",
          "MR": "मॉरिटानिया",
          "MS": "मॉन्ट्सेराट",
          "MT": "माल्टा",
          "MU": "मॉरिशस",
          "MV": "मालदीव",
          "MW": "मलावी",
          "MX": "मेक्सिको",
          "MY": "मलेशिया",
          "MZ": "मोझाम्बिक",
          "NA": "नामिबिया",
          "NC": "न्यू कॅलेडोनिया",
          "NE": "नाइजर",
          "NF": "नॉरफॉक बेट",
          "NG": "नायजेरिया",
          "NI": "निकाराग्वा",
          "NL": "नेदरलँड",
          "NO": "नॉर्वे",
          "NP": "नेपाळ",
          "NR": "नाउरू",
          "NU": "नीयू",
          "NZ": "न्यूझीलंड",
          "OM": "ओमान",
          "PA": "पनामा",
          "PE": "पेरू",
          "PF": "फ्रेंच पॉलिनेशिया",
          "PG": "पापुआ न्यू गिनी",
          "PH": "फिलिपिन्स",
          "PK": "पाकिस्तान",
          "PL": "पोलंड",
          "PM": "सेंट पियरे आणि मिक्वेलोन",
          "PN": "पिटकैर्न बेटे",
          "PR": "प्युएर्तो रिको",
          "PS": "पॅलेस्टिनियन प्रदेश",
          "PT": "पोर्तुगाल",
          "PW": "पलाऊ",
          "PY": "पराग्वे",
          "QA": "कतार",
          "QO": "आउटलाईंग ओशनिया",
          "RE": "रियुनियन",
          "RO": "रोमानिया",
          "RS": "सर्बिया",
          "RU": "रशिया",
          "RW": "रवांडा",
          "SA": "सौदी अरब",
          "SB": "सोलोमन बेटे",
          "SC": "सेशेल्स",
          "SD": "सुदान",
          "SE": "स्वीडन",
          "SG": "सिंगापूर",
          "SH": "सेंट हेलेना",
          "SI": "स्लोव्हेनिया",
          "SJ": "स्वालबर्ड आणि जान मायेन",
          "SK": "स्लोव्हाकिया",
          "SL": "सिएरा लिओन",
          "SM": "सॅन मरीनो",
          "SN": "सेनेगल",
          "SO": "सोमालिया",
          "SR": "सुरिनाम",
          "SS": "दक्षिण सुदान",
          "ST": "साओ टोम आणि प्रिंसिपे",
          "SV": "अल साल्वाडोर",
          "SX": "सिंट मार्टेन",
          "SY": "सीरिया",
          "SZ": "इस्वातिनी",
          "TA": "ट्रिस्टन दा कुन्हा",
          "TC": "टर्क्स आणि कैकोस बेटे",
          "TD": "चाड",
          "TF": "फ्रेंच दाक्षिणात्य प्रदेश",
          "TG": "टोगो",
          "TH": "थायलंड",
          "TJ": "ताजिकिस्तान",
          "TK": "तोकेलाउ",
          "TL": "तिमोर-लेस्ते",
          "TM": "तुर्कमेनिस्तान",
          "TN": "ट्यूनिशिया",
          "TO": "टोंगा",
          "TR": "तुर्की",
          "TT": "त्रिनिदाद आणि टोबॅगो",
          "TV": "टुवालु",
          "TW": "तैवान",
          "TZ": "टांझानिया",
          "UA": "युक्रेन",
          "UG": "युगांडा",
          "UM": "यू.एस. आउटलाइंग बेटे",
          "UN": "संयुक्त राष्ट्र",
          "US": "युनायटेड स्टेट्स",
          "UY": "उरुग्वे",
          "UZ": "उझबेकिस्तान",
          "VA": "व्हॅटिकन सिटी",
          "VC": "सेंट व्हिन्सेंट आणि ग्रेनडाइन्स",
          "VE": "व्हेनेझुएला",
          "VG": "ब्रिटिश व्हर्जिन बेटे",
          "VI": "यू.एस. व्हर्जिन बेटे",
          "VN": "व्हिएतनाम",
          "VU": "वानुआतु",
          "WF": "वालिस आणि फ्यूचूना",
          "WS": "सामोआ",
          "XA": "नकली-उच्चारणे",
          "XB": "नकली-बीडी",
          "XK": "कोसोव्हो",
          "YE": "येमेन",
          "YT": "मायोट्टे",
          "ZA": "दक्षिण आफ्रिका",
          "ZM": "झाम्बिया",
          "ZW": "झिम्बाब्वे",
          "ZZ": "अज्ञात प्रदेश"
        },
        "narrow": {
        },
        "short": {
          "GB": "यू.के.",
          "HK": "हाँगकाँग",
          "MO": "मकाओ",
          "PS": "पॅलेस्टाईन",
          "UN": "यूएन",
          "US": "यू.एस."
        }
      },
      "script": {
        "long": {
          "Adlm": "Adlm",
          "Aghb": "Aghb",
          "Ahom": "Ahom",
          "Arab": "अरबी",
          "Aran": "Aran",
          "Armi": "इम्पिरियल आर्मेनिक",
          "Armn": "अर्मेनियन",
          "Avst": "अवेस्तान",
          "Bali": "बाली",
          "Bamu": "Bamu",
          "Bass": "Bass",
          "Batk": "बटाक",
          "Beng": "बंगाली",
          "Bhks": "Bhks",
          "Blis": "ब्लिसिम्बॉल्स",
          "Bopo": "बोपोमोफो",
          "Brah": "ब्रह्मी",
          "Brai": "ब्रेल",
          "Bugi": "बूगी",
          "Buhd": "बुहिद",
          "Cakm": "चकमा",
          "Cans": "यूनिफाइड कॅनेडियन अ‍ॅबोरिदनल सिलॅबिक्स",
          "Cari": "कॅरियन",
          "Cham": "चाम",
          "Cher": "चेरोकी",
          "Chrs": "Chrs",
          "Cirt": "किर्थ",
          "Copt": "कॉप्टिक",
          "Cpmn": "Cpmn",
          "Cprt": "सायप्रिऑट",
          "Cyrl": "सीरिलिक",
          "Cyrs": "पुरातन चर्च स्लाव्होनिक सिरिलिक",
          "Deva": "देवनागरी",
          "Diak": "Diak",
          "Dogr": "Dogr",
          "Dsrt": "डेसर्ट",
          "Dupl": "Dupl",
          "Egyd": "इजिप्शियन डेमोटिक",
          "Egyh": "इजिप्शियन हायरेटिक",
          "Egyp": "इजिप्शियन हायरोग्लिफ्स",
          "Elba": "Elba",
          "Elym": "Elym",
          "Ethi": "ईथिओपिक",
          "Geok": "जॉर्जियन खुत्सुरी",
          "Geor": "जॉर्जियन",
          "Glag": "ग्लॅगोलिटिक",
          "Gong": "Gong",
          "Gonm": "Gonm",
          "Goth": "गोथिक",
          "Gran": "Gran",
          "Grek": "ग्रीक",
          "Gujr": "गुजराती",
          "Guru": "गुरुमुखी",
          "Hanb": "बोपोमोफोसह हान",
          "Hang": "हंगुल",
          "Hani": "हान",
          "Hano": "हनुनू",
          "Hans": "सरलीकृत",
          "Hant": "पारंपारिक",
          "Hatr": "Hatr",
          "Hebr": "हिब्रू",
          "Hira": "हिरागाना",
          "Hluw": "Hluw",
          "Hmng": "पहाउ मंग",
          "Hmnp": "Hmnp",
          "Hrkt": "जापानी स्वरलिपी",
          "Hung": "पुरातन हंगेरियन",
          "Inds": "सिन्धु",
          "Ital": "जुनी इटालिक",
          "Jamo": "जामो",
          "Java": "जावानीस",
          "Jpan": "जपानी",
          "Kali": "कायाह ली",
          "Kana": "कॅटाकाना",
          "Khar": "खारोश्थी",
          "Khmr": "ख्मेर",
          "Khoj": "Khoj",
          "Kits": "Kits",
          "Knda": "कन्नड",
          "Kore": "कोरियन",
          "Kthi": "काइथी",
          "Lana": "लाना",
          "Laoo": "लाओ",
          "Latf": "फ्रॅक्तुर लॅटिन",
          "Latg": "गाएलिक लेटिन",
          "Latn": "लॅटिन",
          "Lepc": "लेपचा",
          "Limb": "लिम्बू",
          "Lina": "लीनियार अ",
          "Linb": "लीनियर बी",
          "Lisu": "Lisu",
          "Lyci": "लायशियान",
          "Lydi": "लायडियान",
          "Mahj": "Mahj",
          "Maka": "Maka",
          "Mand": "मान्डायीन",
          "Mani": "मानीचायीन",
          "Marc": "Marc",
          "Maya": "मायान हाइरोग्लिफ्स",
          "Medf": "Medf",
          "Mend": "Mend",
          "Merc": "Merc",
          "Mero": "मेरोइटिक",
          "Mlym": "मल्याळम",
          "Modi": "Modi",
          "Mong": "मंगोलियन",
          "Moon": "मून",
          "Mroo": "Mroo",
          "Mtei": "मेइतेइ मायेक",
          "Mult": "Mult",
          "Mymr": "म्यानमार",
          "Nand": "Nand",
          "Narb": "Narb",
          "Nbat": "Nbat",
          "Newa": "Newa",
          "Nkoo": "एन्‘को",
          "Nshu": "Nshu",
          "Ogam": "ओघाम",
          "Olck": "ओल चिकि",
          "Orkh": "ओर्खोन",
          "Orya": "उडिया",
          "Osge": "Osge",
          "Osma": "उस्मानिया",
          "Ougr": "Ougr",
          "Palm": "Palm",
          "Pauc": "Pauc",
          "Perm": "पुरातन पर्मिक",
          "Phag": "फाग्स-पा",
          "Phli": "इन्स्क्रिप्शनल पाहलवी",
          "Phlp": "सॉल्टर पाहलवी",
          "Phlv": "बुक पाहलवी",
          "Phnx": "फोनिशियन",
          "Plrd": "पोलार्ड फोनेटिक",
          "Prti": "इन्स्क्रिप्शनल पर्थियन",
          "Qaag": "Qaag",
          "Rjng": "रीजांग",
          "Rohg": "Rohg",
          "Roro": "रोन्गोरोन्गो",
          "Runr": "रूनिक",
          "Samr": "समरिटान",
          "Sara": "सराती",
          "Sarb": "Sarb",
          "Saur": "सौराष्ट्र",
          "Sgnw": "संकेत लिपी",
          "Shaw": "शॅव्हियन",
          "Shrd": "Shrd",
          "Sidd": "Sidd",
          "Sind": "Sind",
          "Sinh": "सिंहला",
          "Sogd": "Sogd",
          "Sogo": "Sogo",
          "Sora": "Sora",
          "Soyo": "Soyo",
          "Sund": "सूदानी",
          "Sylo": "सिलोती नागरी",
          "Syrc": "सिरीयाक",
          "Syre": "एस्त्ट्रेन्जेलो सिरियाक",
          "Syrj": "पश्चिमी सिरियाक",
          "Syrn": "पूर्वी सिरियाक",
          "Tagb": "तगोआन्वा",
          "Takr": "Takr",
          "Tale": "ताई ली",
          "Talu": "नवीन ताई लू",
          "Taml": "तामिळ",
          "Tang": "Tang",
          "Tavt": "ताई विएत",
          "Telu": "तेलगु",
          "Teng": "तेन्गवार",
          "Tfng": "तिफिनाघ",
          "Tglg": "टागालोग",
          "Thaa": "थाना",
          "Thai": "थाई",
          "Tibt": "तिबेटी",
          "Tirh": "Tirh",
          "Tnsa": "Tnsa",
          "Toto": "Toto",
          "Ugar": "युगारिटिक",
          "Vaii": "वाई",
          "Visp": "दृश्य संवाद",
          "Vith": "Vith",
          "Wara": "Wara",
          "Wcho": "Wcho",
          "Xpeo": "पुरातन फारसी",
          "Xsux": "दृश्यमान भाषा",
          "Yezi": "Yezi",
          "Yiii": "यी",
          "Zanb": "Zanb",
          "Zinh": "वंशपरंपरागत",
          "Zmth": "गणितीय संकेतलिपी",
          "Zsye": "इमोजी",
          "Zsym": "प्रतीक",
          "Zxxx": "अलिखित",
          "Zyyy": "सामान्य",
          "Zzzz": "अज्ञात लिपी"
        },
        "narrow": {
        },
        "short": {
        }
      }
    }
  },
  "locale": "mr"
})
}